import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { NotificationCounts } from "lib/types/notifications"

interface NotificationsState {
  counts: NotificationCounts
  subscriptionsHealthy: boolean
}

const initialState: NotificationsState = {
  counts: {
    failedOps: 0,
    approvalOps: 0,
    failedWorkflows: 0,
    customStateCounts: []
  },
  subscriptionsHealthy: false
}

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotificationCounts: (state, action: PayloadAction<NotificationCounts>) => {
      state.counts = action.payload
    },
    setSubscriptionsHealthy: (state, action: PayloadAction<boolean>) => {
      state.subscriptionsHealthy = action.payload
    }
  }
})

export const { setNotificationCounts, setSubscriptionsHealthy } = notificationsSlice.actions
export default notificationsSlice.reducer
